<template>
  <div class="pageContent shoppingCard">
    <LoadingModal bgcolor="transparent" />
    <div>
      <Top :title="name" :message="tips" />
      <TypeLists :list="arryImg" @selItem="imgClick" />
      <VTitle val="请选择面值" :showLine="false" />
      <ProductDenoList
        :list="arryList"
        @selItem="handleSelList"
        :isMember="isMember"
        :active="activeicon2"
        :vip_discount="vip_discount"
      />
      <VTitle val="充值账号" :showLine="false" />
      <div class="pageBigRadius pageCarServeShadow">
        <van-field
          v-model="account"
          class="pageBigRadius input"
          placeholder="请输入手机号码"
          :error-message="phoneErrorMsg"
          maxlength="11"
          @input="input"
          type="number"
          ref="accounts"
          id="accounts"
        />
      </div>
      <VTitle val="支付方式" :showLine="false" />
      <PayWay
        v-if="balance > 0 || couponsBalanceList.length > 0"
        :sellData="sellData"
        :tips="tips"
        :discount="discount"
        :isWechatPay="wechatpay"
        :type="8"
        :params="params"
        :balance="balance"
        :isMember="isMember"
        :vip_discount="vip_discount"
        :couponsBalanceList="couponsBalanceList"
        :couponsDeduct="couponsDeduct"
        @onComfirm="payHandle"
      />
      <!-- <Tips>
        <div slot="content">
          <ul
            v-if="categoryName === 'jingdong'"
            style="
              list-style: disc;
              color: #000;
              opacity: 0.53;
              margin-left: 15px;
            "
          >
            <li style="list-style: disc">
              <b>如何使用：</b>
              <p>
                1.电脑端：打开京东官网，登录京东账号。“我的京东—我的钱包—礼品卡”，绑定礼品卡处进行绑定
              </p>
              <p>
                2.手机端：手机端登陆APP，点击“我的—我的钱包—礼品卡—绑定新卡”进行绑定
              </p>
            </li>
            <li style="list-style: disc">
              <b>权益说明：</b>
              <p>
                （1）京东E卡为不记名、不挂失、不兑现的产品，已绑定充值至个人京东账户后，亦不支持解绑，不能重新绑定，不能跨京东账户使用。
              </p>
              （2）仅可购买京东官网自营商品，不支持购买出版物、虚拟产品、预售、及抢购商品、投资金银类、夺宝岛、京东国际、京东大药房、第三方卖家商品及受国家政策影响、法律另有限制性规定涉及的商品。
              <p>
                （3）京东E卡有效期请到订单列表查询，逾期尚有余额的不记名卡可提供延期服务，每张卡仅限一次且延长时限为1个月。
              </p>
              <p>（4）用E卡兑付的产品如发生退货时，应退资金将退回至原E卡内。</p>
              <p>
                （5）具体权益详见：<a href="https://o.jd.com"
                  >https://o.jd.com</a
                >。 所有京东E卡相关问题具体可见：<a
                  href="https://help.jd.com/user/issue/list-135.html"
                  >https://help.jd.com/user/issue/list-135.html</a
                >。
              </p>
            </li>
          </ul>
        </div>
      </Tips> -->
    </div>
  </div>
</template>

<script>
import PayWay from "components/PayWay";
import TypeLists from "./ProductTypeList";
import ProductDenoList from "./ProductDenoList";
import { getProductList } from "api/onLine";
import iconList from "server/data/icon.json";
import { buyShoppingCard } from "api/onLine";

export default {
  props: {
    name: String,
    cid: Number,
    type: String,
    balance: Number,
    couponsDeduct: Number,
    isMember: Boolean,
    mouldId: String,
    couponsBalanceList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    TypeLists,
    PayWay,
    ProductDenoList,
  },
  data() {
    return {
      arryImg: [],
      arryList: [],
      activeicon1: "0",
      activeicon2: -1,
      sellData: { sell_price: -1 },
      serviceId: null,
      tips: "",
      describe: "",
      discount: 0,
      index: 0,
      wechatpay: false,
      account: "",
      params: {},
      vip_discount: 0,
      categoryName: "",
      phoneErrorMsg: "",
      isValid: false,
      serviceList: [
        {
          id: "meituan",
          value: [
            {
              productCustomerPrice: "5.000",
              productDenomination: "5.000",
              productFlowVal: "",
              productId: "a01",
              productIsAnyDeno: 0,
              productName: "5元外卖券",
              productNo: "10",
              productPrimePrice: "5.000",
              productStatus: 1,
              productStock: 50,
            },
            {
              productCustomerPrice: "10.000",
              productDenomination: "10.000",
              productFlowVal: "",
              productId: "a02",
              productIsAnyDeno: 0,
              productName: "10元外卖券",
              productNo: "11",
              productPrimePrice: "10.000",
              productStatus: 1,
              productStock: 30,
            },
            {
              productCustomerPrice: "20.000",
              productDenomination: "20.000",
              productFlowVal: "",
              productId: "a03",
              productIsAnyDeno: 0,
              productName: "20元外卖券",
              productNo: "12",
              productPrimePrice: "20.000",
              productStatus: 1,
              productStock: 10,
            },
          ],
        },
        {
          id: "eleme",
          value: [
            {
              productCustomerPrice: "5.000",
              productDenomination: "5.000",
              productFlowVal: "",
              productId: "a01",
              productIsAnyDeno: 0,
              productName: "5元外卖券",
              productNo: "10",
              productPrimePrice: "5.000",
              productStatus: 1,
              productStock: 50,
            },
            {
              productCustomerPrice: "10.000",
              productDenomination: "10.000",
              productFlowVal: "",
              productId: "a02",
              productIsAnyDeno: 0,
              productName: "10元外卖券",
              productNo: "11",
              productPrimePrice: "10.000",
              productStatus: 1,
              productStock: 30,
            },
            {
              productCustomerPrice: "20.000",
              productDenomination: "20.000",
              productFlowVal: "",
              productId: "a03",
              productIsAnyDeno: 0,
              productName: "20元外卖券",
              productNo: "12",
              productPrimePrice: "20.000",
              productStatus: 1,
              productStock: 10,
            },
          ],
        },
        {
          id: "starbucks",
          value: [
            {
              productCustomerPrice: "5.000",
              productDenomination: "5.000",
              productFlowVal: "",
              productId: "a01",
              productIsAnyDeno: 0,
              productName: "5元代金券",
              productNo: "10",
              productPrimePrice: "5.000",
              productStatus: 1,
              productStock: 50,
            },
            {
              productCustomerPrice: "8.000",
              productDenomination: "8.000",
              productFlowVal: "",
              productId: "a02",
              productIsAnyDeno: 0,
              productName: "8元代金券",
              productNo: "11",
              productPrimePrice: "8.000",
              productStatus: 1,
              productStock: 30,
            },
            {
              productCustomerPrice: "15.000",
              productDenomination: "15.000",
              productFlowVal: "",
              productId: "a03",
              productIsAnyDeno: 0,
              productName: "15元代金券",
              productNo: "12",
              productPrimePrice: "15.000",
              productStatus: 1,
              productStock: 10,
            },
          ],
        },
        {
          id: "xicha",
          value: [
            {
              productCustomerPrice: "5.000",
              productDenomination: "5.000",
              productFlowVal: "",
              productId: "a01",
              productIsAnyDeno: 0,
              productName: "5元代金券",
              productNo: "10",
              productPrimePrice: "5.000",
              productStatus: 1,
              productStock: 50,
            },
            {
              productCustomerPrice: "8.000",
              productDenomination: "8.000",
              productFlowVal: "",
              productId: "a02",
              productIsAnyDeno: 0,
              productName: "8元代金券",
              productNo: "11",
              productPrimePrice: "8.000",
              productStatus: 1,
              productStock: 30,
            },
            {
              productCustomerPrice: "15.000",
              productDenomination: "15.000",
              productFlowVal: "",
              productId: "a03",
              productIsAnyDeno: 0,
              productName: "15元代金券",
              productNo: "12",
              productPrimePrice: "15.000",
              productStatus: 1,
              productStock: 10,
            },
          ],
        },
        {
          id: "naixue",
          value: [
            {
              productCustomerPrice: "5.000",
              productDenomination: "5.000",
              productFlowVal: "",
              productId: "a01",
              productIsAnyDeno: 0,
              productName: "5元代金券",
              productNo: "10",
              productPrimePrice: "5.000",
              productStatus: 1,
              productStock: 50,
            },
            {
              productCustomerPrice: "8.000",
              productDenomination: "8.000",
              productFlowVal: "",
              productId: "a02",
              productIsAnyDeno: 0,
              productName: "8元代金券",
              productNo: "11",
              productPrimePrice: "8.000",
              productStatus: 1,
              productStock: 30,
            },
            {
              productCustomerPrice: "15.000",
              productDenomination: "15.000",
              productFlowVal: "",
              productId: "a03",
              productIsAnyDeno: 0,
              productName: "15元代金券",
              productNo: "12",
              productPrimePrice: "15.000",
              productStatus: 1,
              productStock: 10,
            },
          ],
        },
      ],
    };
  },
  created() {
    this.$store.commit("setPageLoading", true);
    this.arryImg = iconList.lifeService;
  },
  mounted() {
    this.categoryName = this.arryImg[0].id;
    this.loadList(this.categoryName);
  },
  methods: {
    handleSelList(i) {
      this.activeicon2 = i;
      this.sellData = {
        ...this.arryList[i],
        sell_price: Number(this.arryList[i].productCustomerPrice),
      };
      this.params.productId = this.arryList[i].productId;
      this.params.mouldId = this.mouldId;
    },
    imgClick(index) {
      this.sellData.sell_price = -1;
      this.activeicon2 = -1;
      this.categoryName = this.arryImg[index].id;
      if (this.activeicon1 !== index) {
        this.activeicon1 = index;
        this.loadList(this.categoryName);
      }
    },
    loadList(ident) {
      this.serviceList.forEach((item) => {
        if (item.id == ident) {
          this.arryList = item.value;
        }
      });
      this.$nextTick(() => {
        this.$store.commit("setPageLoading", false);
      });
      // getProductList(ident, this.mouldId).then((res) => {
      //   if (res.status == 200) {
      //     this.arryList = res.data;
      //   } else {
      //     this.arryList = [];
      //     this.$error(res.message);
      //   }
      //   this.$nextTick(() => {
      //     this.$store.commit("setPageLoading", false);
      //   });
      // });
    },
    input(value) {
      if (!this.$regPhone(value)) {
        this.phoneErrorMsg = "手机号格式错误";
        this.isValid = false;
      } else {
        this.phoneErrorMsg = "";
        this.isValid = true;
      }
      this.params.account = this.account;
    },
    payHandle(data) {
      this.$loading("订单处理中，请稍后...");
      buyShoppingCard(data).then((res) => {
        if (res.status == 200) {
          setTimeout(() => {
            this.$successSync("下单成功", () => {
              this.$push({
                path: "/orders",
                query: { type: "-1" },
              });
            });
          }, 5000);
        } else {
          this.$error(res.message);
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
.shoppingCard {
  .phone {
    margin-top: 10px;
    padding: 10px;
    box-sizing: border-box;
    background: #fff;
    font-weight: 900;
    font-size: 20px;
    color: var(--redColor);
  }
  /deep/ .van-field__control {
    color: #ff3300;
    font-size: 20px;
    font-weight: 900;
  }
}
</style>
